var filter = function() {
  return function(input) {
    if (!!input) { return 'Yes'; }
    return 'No';
  };
};

filter.$inject = [];

tiz.filter('booleanDisplay', filter);
